const actions = {
  /**
   * Fetch the available consultations, getting from $http
   * and commit the data result.
   *
   * @param commit
   * @param $http
   * @param tag
   * @returns {Promise<void>}
   */
  async fetchAvailableConsultations({ commit, rootState: { $http } }, { tag }) {
    const { data } = await $http.get('/endpoints', { params: { tag } });

    const availableConsultations = data.map((consultation) => {
      consultation.value = parseFloat(consultation.value, 10);

      return consultation;
    });

    commit('setAvailableConsultations', availableConsultations);
  },

  async createTemplate({ rootState: { $http } }, form) {
    await $http.post('/template', form);
  },

  async addInTemplate({ rootState: { $http } }, { id, consultation }) {
    await $http.patch(`/template/${id}/consultation`, consultation);
  },

  async renameTemplate({ rootState: { $http } }, { id, name }) {
    console.log(name);
    await $http.patch(`/template/${id}`, { name });
  },

  async removeConsultationInTemplate({ rootState: { $http } }, { templateId, consultationId }) {
    await $http.delete(`/template/${templateId}/consultation/${consultationId}`);
  },

  async delete({ rootState: { $http } }, id) {
    await $http.delete(`/template/${id}`);
  },

  async fetchTemplate({ commit, rootState: { $http } }, id) {
    const { data } = await $http.get(`/template/${id}`);

    commit('setTemplate', data);
  },

  async fetchTemplateDetail({ commit, rootState: { $http } }, id) {
    const { data } = await $http.get(`/template/${id}/detail`);

    commit('setTemplate', data);
  },

  async fetchTemplateList({ commit, rootState: { $http } }, { tag, page }) {
    const { data } = await $http.get('/template', { params: { tag, page } });

    commit('setTemplates', data);
  },
};

export default actions;
